import { SxProps, Theme } from '@mui/material';
import { ReactNode, memo } from 'react';
import MetricCard from './MetricCard';

interface IProps {
  value: ReactNode;
  tabName: string;
  sx?: SxProps<Theme>;
}

const Reach = memo(({ value, tabName, sx }: IProps) => (
  <MetricCard label={`Projected ${tabName} Reach`} value={value} sx={sx} />
));

export default Reach;
